import { IconLockSquareRounded } from '@tabler/icons';

const icons = { IconLockSquareRounded };

const certServices = {
    id: 'allCertServices',
    type: 'group',
    children: [
        {
            id: 'certServices',
            title: 'IT saugos paslaugos',
            type: 'collapse',
            icon: icons.IconLockSquareRounded,
            children: [
                {
                    id: 'certificates',
                    title: 'Skaitmeniniai sertifikatai',
                    type: 'item',
                    url: '/it-saugos-paslaugos/skaitmeniniai-sertifikatai'
                },
                {
                    id: 'networkDevicesSecurityAudit',
                    title: 'Tinklo įrenginių saugumo auditas',
                    type: 'item',
                    url: '/it-saugos-paslaugos/tinklo-irenginiu-saugumo-auditas'
                },
                {
                    id: 'virtualFirewall',
                    title: 'Virtuali ugniasienė',
                    type: 'item',
                    url: '/it-saugos-paslaugos/virtuali-ugniasiene'
                },
                {
                    id: 'itResistanceSimulation',
                    title: 'IT atsparumo simuliacijos ("Phishing")',
                    type: 'item',
                    url: '/it-saugos-paslaugos/it-atsparumo-simuliacijos'
                }
            ]
        }
    ]
};

export default certServices;